import React, { useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faFilter } from "@fortawesome/free-solid-svg-icons";
import logger from "../utils/logger";
import Select from "./select";
import { hoverTips } from "utils/mixin";

const Preffix = styled.div`
  font-size: ${({ theme }) => theme.fontSize.slarge};
  margin-right: 5px;
  cursor: pointer;
  opacity: 0.7;
  ${({ theme, tips }) => hoverTips(theme, tips, "-90%", "-120%")};
  transition: 0.3s;

  &:hover {
    color: ${({ theme }) => theme.dark};
    opacity: 1;
  }
`;

const Suffix = styled.div`
  font-size: ${({ theme }) => theme.fontSize.slarge};
  margin-left: 5px;
  cursor: pointer;
  opacity: 0.7;
  transition: 0.3s;

  &:hover {
    color: ${({ theme }) => theme.dark};
    opacity: 1;
  }
`;

const StyledInput = styled.input`
  display: block;
  width: 240px;
  height: 34px;
  border: none;
  outline: none;
  background: none;
  font-size: 15px;

  &::placeholder {
    text-transform: uppercase;
    color: ${({ theme }) => theme.weakGray};
  }
`;

const StyledSearch = styled.div`
  display: flex;
  align-items: center;
  background-color: white;
  justify-content: center;
  border-radius: 5px;
  padding: 0 10px;
  color: ${({ theme }) => theme.black};
  transition: 0.3s;
`;

const Search = ({
  mode = "normal",
  value,
  setValue,
  onSearch,
  placeholder = "请输入要搜索的内容...",
  ...rest
}) => {
  return (
    <StyledSearch
      mode={mode}
      {...rest}
      onKeyUp={(e) => {
        e.preventDefault();
        //阻止事件进一步传播
        e.stopPropagation();
        switch (e.keyCode) {
          //回车 执行搜索
          case 13:
            onSearch && onSearch(value);
            break;
          default:
            return;
        }
      }}
    >
      <Preffix
        tips="查询"
        onClick={() => {
          onSearch && onSearch(value);
        }}
      >
        <FontAwesomeIcon icon={faSearch} size="sm" />
      </Preffix>
      <StyledInput
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.currentTarget.value)}
      />
      {/* <Suffix>
        <Select
          options={[
            {
              value: "name",
            },
            {
              value: "path",
            },
            {
              value: "info",
            },
          ]}
        />
      </Suffix> */}
    </StyledSearch>
  );
};

export default Search;
